var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 132,
    viewBox: "0 0 166 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.222%",
    y1: "50%",
    x2: "100%",
    y2: "69.237%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9493",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB3A6",
    offset: "82.325%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB3A6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.571%",
    y1: "60.209%",
    x2: "78.375%",
    y2: "42.453%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.156%",
    y1: "94.546%",
    x2: "100%",
    y2: "5.454%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9493",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEB3A6",
    offset: "74.26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD0C5",
    offset: "99.966%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-9.4%",
    y: "-12.8%",
    width: "118.9%",
    height: "125.5%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: 4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745098039 0 0 0 0 0.701960784 0 0 0 0 0.650980392 0 0 0 1 0",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 14,
    dy: -8,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745098039 0 0 0 0 0.701960784 0 0 0 0 0.650980392 0 0 0 0.493983556 0",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-18.1%",
    y: "-19.1%",
    width: "136.1%",
    height: "138.3%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 8,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.854901961 0 0 0 0 0.815686275 0 0 0 0 0.77254902 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.76 64.286c-.182.003-.362.004-.54.004h-.453l-.226-.002h-.387a22.54 22.54 0 0 0-.64.011l.098-.003-.229.008.131-.005a11.763 11.763 0 0 0-.531.03l.097-.008c-.07.005-.14.01-.21.017l.113-.01-.18.017.067-.007a7.16 7.16 0 0 0-.188.02l.121-.013a5.334 5.334 0 0 0-.712.12l.032-.008a3.696 3.696 0 0 0-.166.043l.134-.036a3.51 3.51 0 0 0-.217.061l.083-.025c-.055.016-.11.034-.164.052l.08-.027-.132.046.052-.019a2.602 2.602 0 0 0-.371.162l.052-.027a2.194 2.194 0 0 0-.13.07l.078-.043c-.05.026-.098.055-.144.085l.066-.041a2.009 2.009 0 0 0-.137.088l.07-.047c-.046.03-.09.06-.134.094l.064-.047c-.042.03-.084.062-.123.096l.06-.049a1.83 1.83 0 0 0-.115.096l.055-.047a1.795 1.795 0 0 0-.127.117l.072-.07c-.04.037-.078.075-.115.115l.043-.045a1.77 1.77 0 0 0-.103.114l.06-.069c-.037.04-.071.082-.105.126l.045-.057a1.804 1.804 0 0 0-.108.146l.063-.089a1.83 1.83 0 0 0-.09.131l.027-.042a1.998 1.998 0 0 0-.187.356c-.846 2.075.727 3.039 2.874 3.048l.175-.001a8.056 8.056 0 0 0 .934-.072 9.376 9.376 0 0 0 1.287-.264l.058-.015a24.537 24.537 0 0 1 1.153-.283c.258-.058.547-.118.864-.18l.186-.035a32.812 32.812 0 0 1 .388-.07l.203-.035.173-.029c5.47-.89 16.333-1.25 19.05 9.192l.041.182a3.017 3.017 0 0 1 .055.533l-.004-.124.004.105V77.729l-.002.053-.005.082a2.73 2.73 0 0 1-.488 1.38 2.942 2.942 0 0 1-.593.628l-.03.024a2.63 2.63 0 0 1-.093.068l-.03.02a2.626 2.626 0 0 1-.095.064l-.038.024a2.509 2.509 0 0 1-.3.161 3.056 3.056 0 0 1-.495.18l-.014.005a3.027 3.027 0 0 1-.163.038l-.122.022a2.632 2.632 0 0 1-.14.02l-.02.002a2.545 2.545 0 0 1-.11.01l-.067.004-.105.003H123.974c-.019 0-.037 0-.055-.002h-.026a2.778 2.778 0 0 1-.137-.01l-.03-.003a2.786 2.786 0 0 1-.238-.034 3.12 3.12 0 0 1-.225-.048l.175.039a3.25 3.25 0 0 1-.235-.055l-.27-.067c-1.304-.323-2.44-.547-3.543-.655l-.276-.024a14.907 14.907 0 0 0-.823-.043l-.275-.004-.277.002a14.753 14.753 0 0 0-.84.035l-.286.024a16.414 16.414 0 0 0-.582.062l-.298.04-.302.046-.308.052a22.295 22.295 0 0 0-.962.191l-.335.076c-1.242.29-2.643.706-4.31 1.263l-1.27.422-.854.282c-38.495 12.668-61.815 14.888-77.615 8.228l-.004-.004C12.353 83.564 0 66.597 0 46.735l.006-.773C.418 20.507 21.116 0 46.59 0h6.379c25.731 0 46.59 20.924 46.59 46.735l-.008.891a48.02 48.02 0 0 1-.2 3.524c.002 0 0 .004-.001.01-.026.281-.055.562-.087.841.018.934.412 2.42 2.503 3.325.673.22 1.356.46 2.054.722l-.106-.039.075.028.03.011.081.03c.25.094.494.19.732.287.893.362 1.716.75 2.549 1.236.407.234.782.471 1.123.708l.018.014.057.038c.113.08.223.16.328.24l-.238-.175.044.03c.066.048.13.097.194.145 1.081.82 1.613 1.691 1.692 2.495l.004.048c.003.029.004.058.006.088V61.347l-.002.049c-.035.875-.62 1.648-1.618 2.148l-.094.046a4.697 4.697 0 0 1-.36.152c-.1.037-.199.072-.3.104l-.045.015a7.075 7.075 0 0 1-.768.198 8.935 8.935 0 0 1-.662.111 11.228 11.228 0 0 1-.928.086 16.42 16.42 0 0 1-.812.03z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.55 0c-7.465.01-11.748 9.362-12.36 10.443-1.33 2.348-3.907 4.433-5.875 2.096-.903-1.072-.1-3.053.6-4.186 1.182-1.913-.392-4.31-2.616-4.011C27.421 5.8 14.97 17.242 17.5 31.833c1.327 7.648 10.533 17.238 25.8 10.048 10.184-5.296 11.523-15.408 13.567-27.25.92-5.329 3.365-7.797 5.775-8.9 2.078-.951 2.138-3.903.044-4.816C61.227.278 59.859.003 58.583 0h-.033z",
    id: "g"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FEA948",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 35a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM28 12v18h-5V12h5z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D8D8D8",
    opacity: 0.3,
    cx: 50,
    cy: 127.5,
    rx: 48,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.828 127c-1.58 0-2.862-1.503-2.862-3.355v-13.07c0-1.854 1.282-3.356 2.862-3.356s2.86 1.502 2.86 3.356v13.07c0 1.852-1.28 3.355-2.86 3.355",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.21)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.843-3.925c-8.231.005-12.955 5.175-13.63 5.772-1.466 1.298-4.308 2.451-6.478 1.16-.994-.593-.11-1.689.662-2.315 1.303-1.058-.432-2.382-2.884-2.217-11.995.806-25.725 7.131-22.935 15.197 1.463 4.228 11.615 9.529 28.449 5.554 11.23-2.928 12.182-9.345 16.222-14.37 1.015-2.946 5.883-.89 8.541-1.499 2.292-.526-1.077-6.272-3.386-6.777a21.25 21.25 0 0 0-4.524-.505h-.037z",
    fill: "url(#d)",
    opacity: 0.153,
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.48 57.506a2.304 2.304 0 0 1-2.3 2.308 2.305 2.305 0 0 1-2.302-2.308 2.305 2.305 0 0 1 2.301-2.308c1.271 0 2.301 1.033 2.301 2.308M38.215 57.506a2.304 2.304 0 0 1-2.301 2.308 2.305 2.305 0 0 1-2.301-2.308 2.305 2.305 0 0 1 2.3-2.308c1.272 0 2.302 1.033 2.302 2.308",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.716 61.84c-3.773 0-6.832 3.07-6.832 6.854h13.664c0-3.785-3.059-6.853-6.832-6.853M26.897 82.342a4.659 4.659 0 0 0 4.652-4.666h-9.304a4.659 4.659 0 0 0 4.652 4.666",
    fill: "#FEA948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#635A4C",
    d: "M21.954 68.67h9.871v8.983h-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.908 127c-1.58 0-2.861-1.503-2.861-3.355v-13.07c0-1.854 1.281-3.356 2.861-3.356 1.58 0 2.861 1.502 2.861 3.356v13.07c0 1.852-1.28 3.355-2.86 3.355",
    fill: "#1D1D1B"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgError);
export default __webpack_public_path__ + "static/media/img_error.54de0668.svg";
export { ForwardRef as ReactComponent };